import React from 'react'
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

function AddDateRange({ setNewAdditionRange, newAdditionRange, additionError, handleAddAddition }) {
  return (
    <div className="modal-content-custom">
        <label className="form-label">Select Date Range</label>
        <DateRangePicker 
            onChange={setNewAdditionRange} 
            value={newAdditionRange}
            clearIcon={null}
            calendarIcon={null}
            className={"form-control"}
        />
        {additionError && <div className="error-message mt-2">{additionError}</div>}
        <button 
            className="btn-save mt-2"
            onClick={handleAddAddition}
        >
            Add Range
        </button>
    </div>
  )
}

export default AddDateRange
